import { render, staticRenderFns } from "./UserStatPanel.vue?vue&type=template&id=0bc42da1&scoped=true&lang=pug&"
import script from "./UserStatPanel.vue?vue&type=script&lang=js&"
export * from "./UserStatPanel.vue?vue&type=script&lang=js&"
import style0 from "./UserStatPanel.vue?vue&type=style&index=0&id=0bc42da1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc42da1",
  null
  
)

export default component.exports